export const NOTIFICATION_EXPIRATION_DELAY = 15000;
